import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IAccrualsConfig } from "../interface/AccrualsConfig/IAccrualsConfig";

enum AccrualsConfigServiceEnum {
  getAll = "/",
}

export default class AccrualsConfigService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/accruals-config");
  }

  public getAll = async (): Promise<IAccrualsConfig[]> => await this.GET(AccrualsConfigServiceEnum.getAll);
}
